import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "../../UI/addForm.css";
import global from "../../config";
import Header from "../Header/Header";
import "./ManageCreators.css";
import Footer from "../Footer/Footer";

export default function AddCreator(props) {
  const [slug, setSlug] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [editID, setEditID] = useState("");
  const [slugError, setSlugError] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [addUpdateError, setAddUpdateError] = useState("");
  const [addUpdateSuccess, setAddUpdateSuccess] = useState("");

  const navigate = useNavigate();
  const { creatorID } = useParams();

  const submitClick = async () => {
    if (slug.trim() === "") {
      setSlugError(true);
    }
    if (name.trim() === "") {
      setNameError(true);
    }

    const clearForm = () => {
      setSlug("");
      setName("");
      setDescription();
      setEditID("");
      setSlugError("");
      setNameError("");
      setAddUpdateError("");
      setAddUpdateSuccess("");
    };

    if (slugError === false) {
      const idToken = localStorage.getItem("idToken");

      const postPayload = {
        operation: "add",
        CreatorName: name,
        CreatorSlug: slug,
        CreatorDescription: description,
      };

      const editPayload = {
        operation: "edit",
        CreatorName: name,
        CreatorSlug: slug,
        CreatorDescription: description,
      };

      if (editID === "") {
        try {
          const response = await axios.post(
            global.apiURL + "/creators",
            postPayload,
            { headers: { Authorization: "Bearer " + idToken } }
          );
          if (response) {
            setAddUpdateSuccess("Creator added");
            setTimeout(clearForm, 2000);
          } else {
            console.log("Error");
          }
        } catch (e) {
          setAddUpdateError("Creator's folder slug already exists");
          console.log(e);
        }
      } else {
        try {
          const response = await axios.post(
            global.apiURL + "/creators",
            editPayload,
            { headers: { Authorization: "Bearer " + idToken } }
          );

          if (response) {
            setAddUpdateSuccess("Creator Updated");
            setTimeout(clearForm, 2000);
          } else {
            console.log("Error");
          }
        } catch (e) {
          setAddUpdateError("Some error occured");
          console.log("Cannot update creator");
        }
      }
    } else {
      props.onActionAddError();
    }
  };

  const txtValue = (e) => {
    if (e.target.name === "txtName") {
      setName(e.target.value);
      if (e.target.value.trim() === "") {
        setNameError(true);
      } else {
        if (!editID) {
          setSlug(createSlug(e.target.value));
        }
        setNameError(false);
      }
    }
    if (e.target.name === "txtSlug") {
      setSlug(e.target.value);
      if (e.target.value.trim() === "") {
        setSlugError(true);
      } else {
        setSlugError(false);
      }
    }
    if (e.target.name === "txtDescription") {
      setDescription(e.target.value);
    }
  };

  function createSlug(text) {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-") // Replace spaces and special chars with hyphen
      .replace(/^-+|-+$/g, ""); // Remove leading and trailing hyphens
  }

  const getDetails = async () => {
    const idToken = localStorage.getItem("idToken");

    if (creatorID) {
      const payLoadCreator = {
        operation: "search",
        searchCriteria: { _id: creatorID },
      };
      const respCreator = await axios.post(
        global.apiURL + "/creators/",
        payLoadCreator,
        {
          headers: { Authorization: "Bearer " + idToken },
        }
      );
      if (respCreator.data.data.length > 0) {
        setName(respCreator.data.data[0].CreatorName);
        setSlug(respCreator.data.data[0].CreatorSlug);
        setDescription(respCreator.data.data[0].CreatorDescription);
        setEditID(respCreator.data.data[0]._id);
      }
    }

  };

  useEffect(() => {
    getDetails();
  }, []);

  return (
    <>
      <div class="wrap-over-container">
        <Header />

        <div className="admin-body">
          <div className="container">
            <div className="admin-panel">
              <div className="adheader-form">
                <h3>{creatorID ? "Edit" : "Add"} Creator</h3>
                <div className="admin-panel-header-right">&nbsp;</div>

                <div className="adbody">
                  <span className="errorMsg">{addUpdateError}</span>
                  <span className="successMsg">{addUpdateSuccess}</span>

                  <div className="add-dialog-form-group">
                    <label>
                      Creator Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      onChange={txtValue}
                      name="txtName"
                      id="txtName"
                      placeholder="Enter Creator name"
                      value={name}
                    />
                    {nameError === true && (
                      <p className="error">Creator name is required</p>
                    )}
                  </div>

                  <div className="add-dialog-form-group">
                    <label>
                      Folder Slug <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      onChange={txtValue}
                      name="txtSlug"
                      id="txtSlug"
                      placeholder="Enter Folder Slug"
                      value={slug}
                      readOnly
                    />
                    {slugError === true && (
                      <p className="error">Folder Slugs is required</p>
                    )}
                  </div>

                  <div className="add-dialog-form-group">
                    <label>Creator Decsription</label>
                    <input
                      type="text"
                      onChange={txtValue}
                      name="txtDescription"
                      id="txtDescription"
                      placeholder="Enter creator Description"
                      value={description}
                    />
                  </div>

                  <div className="add-dialog-footer">
                    <button
                      type="button"
                      className="add-dialog-submit"
                      onClick={submitClick}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    </>
  );
}
